<template>
  <div class="filters-card">
    <div class="filters-grid">
      <div class="filter-group">
        <label class="filter-label">
          <i class="fas fa-user filter-icon"></i>
          Nome
        </label>

        <v-text-field
          :disabled="buy.status == 'EFETUADO'"
          v-model="buy.name"
          placeholder="Digite o nome da lista de compras"
          outlined
          dense
          hide-details
          class="modern-input"
        />
      </div>

      <div class="filter-group">
        <label class="filter-label">
          <i class="fas fa-clock filter-icon"></i>
          Data para realizar a compra
        </label>

        <v-text-field
          :disabled="buy.status == 'EFETUADO'"
          v-model="buy.date_be_made"
          label="Selecionar Data"
          type="date"
          outlined
          dense
          hide-details
          class="modern-input"
        />
      </div>

      <div class="filter-group">
        <label class="filter-label">
          <i class="fas fa-user filter-icon"></i>
          Usuário responsável pela compra
        </label>

        <v-select
          :disabled="buy.status == 'EFETUADO'"
          v-model="buy.user_id_will_buy"
          :items="users"
          item-text="name"
          item-value="id"
          clearable
          outlined
          ref="residentSelect"
          class="modern-select"
          placeholder="Selecione o usuário"
        />
      </div>
    </div>

    <div class="filter-group">
      <label class="filter-label">
        <i class="fas fa-search filter-icon"></i>
        Anotação
      </label>

      <v-textarea
        :disabled="buy.status == 'EFETUADO'"
        v-model="buy.note"
        placeholder="Digite a anotação"
        outlined
        dense
        hide-details
        class="modern-input"
        maxlength="255"
      />
    </div>

    <div class="form-actions">
      <v-btn
        v-if="buy.status != 'EFETUADO'"
        :disabled="loading"
        class="btn-save-modern"
        @click="update"
      >
        <i class="fas fa-save mr-2"></i>
        {{ loading ? "Salvando..." : "SALVAR LISTA DE COMPRAS" }}
      </v-btn>
    </div>

    <ErrorsMessages :errors="errors" />
  </div>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";

import toast from "../../lib/ToastNotification";

import api from "../../services/api";

import moment from "moment";

import routes from "../../routes";

import permission from "../../lib/permission";

export default {
  name: "BuyUpdate",

  components: {
    ErrorsMessages,
  },

  props: {
    buy: {
      type: [Array, Object],
      default: null,
    },
  },

  data() {
    return {
      loading: null,

      users: [],

      errors: [],
    };
  },

  mounted() {
    this.getUsers();

    if (this.buy.length != 0) {
      this.buy.date_be_made = moment(this.buy.date_be_made).format(
        "YYYY-MM-DD"
      );
    }
  },

  methods: {
    moment,
    permission,

    async getUsers() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/users");

        const { error, users } = response.data;

        if (!error) {
          this.users = users;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.error(error);
      }
    },

    async update() {
      try {
        this.loading = true;

        const id = this.buy.id;
        const name = this.buy.name;
        const date_be_made = this.buy.date_be_made;
        const user_id_will_buy = this.buy.user_id_will_buy;
        const note = this.buy.note;

        let params = {
          id,
          name,
          date_be_made,
          user_id_will_buy,
          note,
        };

        const response = await api.put("/buy", params);

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.handleToBack();
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    handleToBack() {
      routes.go(-1);
    },
  },
};
</script>

<style scoped>
.form-actions {
  display: flex;
  justify-content: flex-end;
  padding: 16px;
}

.form-actions > *:not(:last-child) {
  margin-right: 8px;
}
</style>